// extracted by mini-css-extract-plugin
var _1 = "TeacherModal__backdrop--Q9WAA ModalGeneral__backdrop--gxZiG";
var _2 = "TeacherModal__button--r8f6Z CoreGeneral__colorButtonBase--ROvbs CoreGeneral__roboto--UlmjE";
var _3 = "TeacherModal__buttonLarge--zJc9X TeacherModal__button--r8f6Z CoreGeneral__colorButtonBase--ROvbs CoreGeneral__roboto--UlmjE";
var _4 = "TeacherModal__buttons--oskcc";
var _5 = "TeacherModal__disabled--DCvz2";
var _6 = "TeacherModal__heightAuto--DyHUq";
var _7 = "TeacherModal__modal--XYqj6 CoreGeneral__roboto--UlmjE";
export { _1 as "backdrop", _2 as "button", _3 as "buttonLarge", _4 as "buttons", _5 as "disabled", _6 as "heightAuto", _7 as "modal" }
